<div class="loader-ellipsis">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
